import type { RequestConfig } from '@umijs/max';

export const errorConfig: RequestConfig = {
  baseURL: "https://tata-api.aydentify.com",
  // baseURL: "https://api-v1.aydentify.com",
  // baseURL: "https://tata-api.aydentify.com",
  withCredentials: true,
};
